export const UPDATE_CURRENT_ITEM_QUANTITY = 'UPDATE_CURRENT_ITEM_QUANTITY';
export const COMPLETE_ADD_ITEM_TO_ORDER_SUMMARY = 'COMPLETE_ADD_ITEM_TO_ORDER_SUMMARY';
export const ADD_ITEM_TO_ORDER_SUMMARY_FAILED = 'ADD_ITEM_TO_ORDER_SUMMARY_FAILED';
export const INITIATE_ADD_ITEM_TO_BUNDLE = 'INITIATE_ADD_ITEM_TO_BUNDLE';
export const ADD_ORDER_SUMMARY = 'ADD_ORDER_SUMMARY';
export const START_REMOVE_ITEM_FROM_BUNDLE = 'START_REMOVE_ITEM_FROM_BUNDLE';
export const ADD_ORDER_SUMMARY_TO_CART = 'ADD_ORDER_SUMMARY_TO_CART';
export const SET_LINE_ITEM_PRICE = 'SET_LINE_ITEM_PRICE';
export const REMOVE_ITEM_IN_BUNDLE_FROM_STORE = 'REMOVE_ITEM_IN_BUNDLE_FROM_STORE';
export const CREATE_PURCHASED_LOGO = 'CREATE_PURCHASED_LOGO';
export const CREATE_PURCHASED_LOGO_FAILED = 'CREATE_PURCHASED_LOGO_FAILED';
export const CREATE_ORDER_LINEITEM_LOGO = 'CREATE_ORDER_LINEITEM_LOGO';
export const CREATE_ORDER_LINEITEM_LOGO_FAILED = 'CREATE_ORDER_LINEITEM_LOGO_FAILED';
export const ADD_PREV_LOGO_TO_NEWLINEITEM = 'ADD_PREV_LOGO_TO_NEWLINEITEM';
export const ADD_LIQUIDPIXEL_UPDATED_LOGO = 'ADD_LIQUIDPIXEL_UPDATED_LOGO';
export const ADD_LIQUIDPIXEL_LOGO_FAILS = 'ADD_LIQUIDPIXEL_LOGO_FAILS';
export const COMPLETE_LIQUIDPIXEL_UPDATED_LOGO = 'COMPLETE_LIQUIDPIXEL_UPDATED_LOGO';
export const MERGE_LINE_ITEM_TO_BUNDLE = 'MERGE_LINE_ITEM_TO_BUNDLE';
export const LINE_ITEM_NOT_TO_BE_REMOVED = 'LINE_ITEM_NOT_TO_BE_REMOVED';
export const ADD_PREV_LOGO_TO_NEWLINEITEM_FAILED = 'ADD_PREV_LOGO_TO_NEWLINEITEM_FAILED';
export const SKU_EXISTS = 'SKU_EXISTS';
